<template>
    <!--
    Wrapper for tab components
    -->
    <div>
        <div class="tabs" :class="'tab-active--' + activeTab">
            <a href="#" v-for="tab in tabs"

                v-if="isContentTab(tab.index)"

                :class="{
                    'is-active': tab.index == activeTab || tab.index == 1 && activeTab == 0 && !isMobile
                }"

                @click.prevent="setActiveTab(tab.index)"
            >

                {{ tab.title }}

                <em v-if="tab.count">{{ tab.count }}</em>

            </a>
        </div>

        <div class="tab-details">
            <slot />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'Tabs',

    data()
    {
        return {
            tabs: []
        }
    },

    created()
    {
        this.tabs = this.$children;
    },

    methods:
    {
        /**
         * Determine if current tab is a content or a sidebar-content tab.
         *
         * @param index
         * @returns {boolean}
         */
        isContentTab(index)
        {
            return (this.mainContentTab && this.isMobile && index === 0 || index != 0);
        },

        /**
         * Is current tab active, based on index from the store
         * @param index
         */
        setActiveTab(index)
        {
            this.$store.dispatch('sidebar/setActiveTab', index);
        }
    },

    computed:
    {
        /**
         * Is viewport in mobile mode
         *
         * @returns {boolean}
         */
        isMobile()
        {
            return this.viewport != 'd' && this.viewport != 'tl';
        },

        ...mapState({
            viewport: ({ layout }) => layout.viewport,
            activeTab: ({ sidebar }) => sidebar.tab.activeTab,
            mainContentTab: ({ sidebar }) => sidebar.tab.mainContentTab,
        })
    },
}
</script>



// WEBPACK FOOTER //
// Tabs.vue?6e3f2500